import React, { useEffect, useState } from "react";
import { FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetCategory } from "../redux/slices/GetCategorySlice";
import endPoint from "../redux/EndPoint/endpoint";
import axios from "axios";

const CategorySection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeCategoryId, setActiveCategoryId] = useState(null);
  const { AllCategory } = useSelector((state) => state.category);
  const [startIndex, setStartIndex] = useState(0);
  const [subCategories, setCategories] = useState([]);
  const itemsPerPage = 4;

  useEffect(() => {
    dispatch(GetCategory());
  }, [dispatch]);

  const handleCategoryClick = (category) => {
    setActiveCategory((prev) =>
      prev === category?.name ? null : category?.name
    );

    _showCategory(category?._id);
    setActiveCategoryId(category?._id);
  };

  const _showCategory = async (category) => {
    try {
      const response = await axios.get(endPoint.GETCATEGORY, {
        params: {
          parentId: category,
        },
      });
      setCategories(response.data);
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleViewAllCategories = () => {
    navigate("/ViewAllCategory");
  };

  const visibleCategories = AllCategory.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handleNext = () => {
    if (startIndex + itemsPerPage < AllCategory.length) {
      setStartIndex(startIndex + itemsPerPage);
    }
  };

  const handlePrevious = () => {
    if (startIndex - itemsPerPage >= 0) {
      setStartIndex(startIndex - itemsPerPage);
    }
  };

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  const _handleClick = (name) => {
    if (activeCategory || name) {
      localStorage.setItem("activeCategory", activeCategory);

      navigate(
        `/category/${generateSlug(activeCategory)}/${generateSlug(name)}`,
        {
          state: { name, activeCategoryId, activeCategory },
        }
      );
      setActiveCategory("null");
    } else {
      alert("Invalid category or subcategory. Please select a valid category.");
    }
  };

  return (
    <>
      <div className=" w-[95%] flex justify-end mt-1 ">
        <button
          onClick={handleViewAllCategories}
          className="sm:hidden text-blue-500 font-medium text-sm sm:text-base flex items-center mb-1"
        >
          View All
          <FaChevronRight className="ml-2" />
        </button>
      </div>
      <div className="flex justify-center items-center z-50 self-center">
        <div className="flex gap-3 sm:gap-3 overflow-x-auto w-full self-center justify-center items-center">
          <div className="w-[90%] self-center items-center justify-center flex bg-gray-100 to-white  bg-gray-10 pb-3">
            <div className="sm:hidden  flex flex-col w-[100%] bg-gray-100 relative">
              <h1 className="text-black m-2 text-lg font-bold">Categories</h1>
              <div className="flex flex-row  items-center justify-center ">
                {startIndex > 0 && (
                  <button
                    onClick={handlePrevious}
                    className="z-10 fixed  flex absolute left-[-13px] h-20 w-10 justify-center items-center"
                  >
                    <button className="  text-blue-500 font-medium text-sm flex items-center h-8 w-8 rounded-full justify-center bg-gray-300">
                      <FaChevronRight className="rotate-180" />
                    </button>
                  </button>
                )}

                {visibleCategories?.map((category, index) => (
                  <div
                    key={index}
                    className="relative flex flex-col items-center cursor-pointer  w-96 overflow-hidden"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCategoryClick(category);
                    }}
                  >
                    <img
                      src={category.image}
                      alt={category.name}
                      className="w-14 h-14 rounded-full object-cover mb-2"
                    />
                    <button className="text-black font-medium hover:text-red-700 text-sm sm:text-base whitespace-nowrap overflow-hidden text-ellipsis  w-[95%]">
                      {category.name}
                    </button>
                  </div>
                ))}

                {startIndex + itemsPerPage < AllCategory.length && (
                  <button
                    className="absolute right-[-13px] text-blue-500 font-medium text-sm flex items-center  h-8 w-8 rounded-full justify-center bg-gray-300"
                    onClick={handleNext}
                  >
                    <FaChevronRight />
                  </button>
                )}
              </div>
            </div>
            <div className=" hidden sm:flex flex-row overflow-x-auto gap-10 items-center bg-transparent p-3">
              {AllCategory?.slice(0, 8).map((category, index) => (
                <div
                  key={index}
                  className="relative flex flex-col items-center cursor-pointer mt-3"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCategoryClick(category);
                  }}
                >
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-12 h-12 rounded-full object-cover mb-2"
                  />
                  <button
                    className="text-black font-medium hover:text-red-700 text-sm sm:text-base 
                  whitespace-nowrap overflow-hidden text-ellipsis"
                  >
                    {category.name}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="justify-between items-center w-[90%] mx-auto hidden sm:flex py-1 ">
        <h2 className="text-lg font-semibold"></h2>
        <button
          onClick={handleViewAllCategories}
          className="flex  text-blue-500 font-medium text-sm sm:text-base items-center"
        >
          View All Categories
          <FaChevronRight className="ml-2" />
        </button>
      </div>

      {/* {subCategories?.length > 0 && (
        <div className="flex justify-center items-center py-0 z-50">
          <div className="flex gap-3 overflow-x-auto w-full justify-center items-center">
            <div className="w-[90%] flex flex-wrap gap-10 justify-center items-center bg-gray-100 p-4 rounded-lg">
              {subCategories.map((subcategory, subIndex) => (
                <div
                  key={subIndex}
                  onClick={() => _handleClick(subcategory.name)}
                  className="flex-shrink-0 flex flex-col items-center cursor-pointer"
                >
                  <div className="flex items-center justify-center  w-36 h-12 rounded-3xl bg-gray-300">
                    <p className="text-center text-sm font-semibold text-black px-2 mt-3 line-clamp-1">
                      {subcategory.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )} */}
      {subCategories?.length > 0 && (
        <div className="flex justify-center items-center py-0 z-50">
          <div className="w-full flex justify-center items-center">
            <div
              className={`
          w-[90%] mx-auto bg-gray-100 p-4 rounded-lg gap-4
          flex overflow-x-auto sm:grid sm:overflow-visible
          sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6
        `}
            >
              {subCategories.map((subcategory, subIndex) => (
                <div
                  key={subIndex}
                  onClick={() => _handleClick(subcategory.name)}
                  className="cursor-pointer shrink-0"
                >
                  <div className="flex items-center justify-center w-36 h-12 rounded-3xl bg-gray-200">
                    <p className="text-sm font-semibold text-black text-center px-2 truncate mt-3">
                      {subcategory.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default CategorySection;
